export const NotExpandedHeight = 120;
export const DefaultExpandContentId = 'expand-content';
